exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.legend-helper[data-v-41c7f3f4] {\n    position: absolute;\n    left: -20px;\n}\n", ""]);

// exports
